import { render, staticRenderFns } from "./ThreeColumnSelector.vue?vue&type=template&id=f1c5541c&scoped=true&"
import script from "./ThreeColumnSelector.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnSelector.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumnSelector.vue?vue&type=style&index=0&id=f1c5541c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c5541c",
  null
  
)

export default component.exports